import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../../misc';

const NotificationDialogAction = ({ msgType, onClick }) => {
  return (
    <button className="accept" onClick={onClick}>
      <FormattedMessageWrappedInSpan id="notificationDialogAction.default" defaultMessage="Ok" />
    </button>
  );
};


NotificationDialogAction.propTypes = {
  msgType: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotificationDialogAction;
